import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../utils/api";

/**
 * OnboardingCheck - Wrapper component that ensures users have completed onboarding
 * Redirects to /onboarding if user has no categories or currencies
 */
function OnboardingCheck({ children }) {
  const [needsOnboarding, setNeedsOnboarding] = useState(null);
  const navigate = useNavigate();

  const checkOnboardingStatus = useCallback(async () => {
    try {
      // Check if user has any categories and currencies
      const [categoriesRes, currenciesRes] = await Promise.all([
        apiGet("/categories"),
        apiGet("/currencies")
      ]);

      const categories = await categoriesRes.json();
      const currencies = await currenciesRes.json();

      // User needs onboarding if they have no categories OR no currencies
      if (categories.length === 0 || currencies.length === 0) {
        setNeedsOnboarding(true);
        navigate("/onboarding");
      } else {
        setNeedsOnboarding(false);
      }
    } catch (error) {
      console.error("Error checking onboarding status:", error);
      // On error, allow through to avoid blocking user
      setNeedsOnboarding(false);
    }
  }, [navigate]);

  useEffect(() => {
    checkOnboardingStatus();
  }, [checkOnboardingStatus]);

  // Show loading state while checking
  if (needsOnboarding === null) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "var(--font-size-large)",
        color: "var(--text-secondary)"
      }}>
        Laden...
      </div>
    );
  }

  // If user doesn't need onboarding, render children
  if (needsOnboarding === false) {
    return <>{children}</>;
  }

  // If redirecting to onboarding, show nothing (navigation in progress)
  return null;
}

export default OnboardingCheck;
